/**
 * Global-search bounds as plain data — deliberately zod-free.
 *
 * Same reason as `errorCodes.ts` and `features.ts`: `CommandPalette` is mounted
 * by `AppShell`, so it is on the boot path of every page. Reading these three
 * numbers out of `schemas/search.schema.ts` would pull that zod module — and,
 * through the `@attendance/shared` barrel, all the others — into the entry
 * chunk to learn that the minimum query length is 2.
 *
 * `search.schema.ts` re-exports them and stays the validation source of truth.
 */

/**
 * Shortest query the endpoint will answer. Two characters is enough to make a
 * single-letter sweep of the alphabet — 26 requests that between them enumerate
 * everybody — not work. Enforced in the schema, so a shorter `q` is a 422 and
 * NOT an empty result: "too short" and "no matches" are different answers and
 * the client renders them differently.
 */
export const SEARCH_MIN_QUERY_LENGTH = 2;

/** Longest `q` accepted. Bounds the LIKE pattern; well past any real name. */
export const SEARCH_MAX_QUERY_LENGTH = 100;

/** Hard per-entity cap. Five is a palette group; it is not a report page. */
export const SEARCH_PER_ENTITY_LIMIT = 5;
